function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M8.039 13.5H6L.712 8.212a.3.3 0 0 1 0-.424l1.076-1.076a.3.3 0 0 1 .424 0L6 10.5 6.039 0H8v10.5l3.788-3.788a.3.3 0 0 1 .424 0L13.29 7.79a.3.3 0 0 1 0 .423L8.04 13.5z",
  fill: "#1063CD"
});

const SvgArrow = props => React.createElement("svg", _extends({
  width: 14,
  height: 14,
  fill: "none"
}, props), _ref);

export default SvgArrow;